import messages from './ProfilUtilisateur.json'
import ChangerPassword from './ChangerPassword/ChangerPassword.vue'
import BtnRetour from 'src/components/Dashboard/Layout/BtnRetour/BtnRetour.vue'
import swal from 'sweetalert2'

export default {
  name: "ProfilUtilisateur",
  i18n: messages,

  components: {swal, ChangerPassword, BtnRetour},

  data() {
    return {


      form: {
        id: null,
        nom: null,
        prenom: null,
        mail: null,
        date: '',
        actif: null,
        supprime: null,
        admin: null,
        validations: {
          nom: {
            required: true
          },
          actif: {
            required: true
          }
        }
      },
      isAdmin: null,
      modification: true,
      ownProfil : null,

      // Données reçues du back
      data: null
    }
  },

  mounted() {
    // Soit depuis la route, soit depuis l'utilisateur courant.
    if (this.$val.isDefined(this.$route.params.idUser)) {
      this.updateData(this.$route.params.idUser)
    } else {
      this.updateData(this.$store.getters.user.id)
    }
  },

  computed: {
    formatDate: {
      get(row) {
        return [row.dateDebut, row.dateFin]
      },
      set(values, index) {
        this.form.datesPoste[index]
      }
    }
  },

  methods: {
    /**
     * Récupération des données
     */
    updateData(idUser) {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      this.$axios.get('rest/bd/utilisateur/' + idUser).then(
        response => {
          this.data = response.data
          this.modification = response.data.modification
          this.ownProfil = (this.$store.getters.user.id === response.data.id) ? true : false
          this.isAdmin = this.$store.getters.user.admin
          this.form.id = ((this.$val.isDefined(response.data.id)) ? response.data.id : null)
          this.form.login = ((this.$val.isDefined(response.data.login)) ? response.data.login : null)
          this.form.nom = ((this.$val.isDefined(response.data.nom)) ? response.data.nom : null)
          this.form.prenom = ((this.$val.isDefined(response.data.prenom)) ? response.data.prenom : null)
          this.form.mail = ((this.$val.isDefined(response.data.mail)) ? response.data.mail : null)
          this.form.postesEnCours = response.data.postesEnCours
          this.form.postesFutur = response.data.postesFutur
          this.form.actif = response.data.actif
          this.form.admin = response.data.admin
          this.form.supprime = response.data.supprime
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
        error => {
          this.error(error.response)
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        }
      )
    },

    /**
     * Fonction permettant de retourner sur la page d'accueil'
     */
    reset() {
      this.$router.push({
        path: '/pages/user/acces'
      })
    },

    /**
     * Fonction permettant la suppression (logique) de l'utilisateur
     */
    supprimer() {
      swal({
        title: this.$t('confirmation.suppression.titre'),
        text: this.$t('confirmation.suppression.texte'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: this.$t('confirmation.suppression.valider'),
        cancelButtonText: this.$t('confirmation.suppression.annuler'),
        buttonsStyling: false
      }).then((result) => {
        this.$axios.delete('rest/bd/utilisateur/suppression/' + this.data.id).then(
          response => {
            this.$eventHub.$emit(this.$eventHub.SHOW_NOTIF, 'success', this.$t('notifications.succesSuppression.title'), this.$t('notifications.succesSuppression.message'))
            this.reset();
            this.$eventHub.$emit(this.$eventHub.LOADING.END);

          },
          error => {
            this.$eventHub.$emit(this.$eventHub.SHOW_NOTIF, 'error', this.$t('notifications.echecSuppression.title'), this.$t('notifications.echecSuppression.message'))
            this.$eventHub.$emit(this.$eventHub.LOADING.END);
          }
        )
      })
    },

    /**
     * Fonction d'enregistrement des modifications
     */
    enregistrer() {
      this.$validator.validateAll().then(isValid => {

        // Si la validation echoue : on arrete.
        if (!isValid) {
          return;
        }

        // Appel au WS de modif des info utilisateur
        this.$eventHub.$emit(this.$eventHub.LOADING.START)
        this.$axios.put('/rest/bd/utilisateur/' + this.form.id, this.form).then(
          response => {
            this.success(response)
            this.$eventHub.$emit(this.$eventHub.LOADING.END)
          }, error => {
            this.error(error.response)
            this.$eventHub.$emit(this.$eventHub.LOADING.END)
          }
        )
      })
    },

            /**
     * Fonction permettant d'enlever la suppression (logique) de l'utilisateur
     */
    retablir() {
      this.$axios.delete('rest/bd/utilisateur/retablir/' + this.data.id).then(
        response => {
          this.$notify.success({
            title: this.$t('notifications.success.title'),
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END);
          this.reset();

        },
        error => {
          this.$notify.error({
            title: this.$t('notifications.error.title'),
            message: this.$t('notifications.error.message')
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END);
        }
      )
  },

    /**
     * Appel service backend de suppression
     * @param {*} index
     */
    supprimerPoste(index) {
      let poste = this.$val.isDefined(this.form.postesEnCours[index]) ? this.form.postesEnCours[index] : this.postesFutur[index]
      this.$eventHub.$emit(this.$eventHub.LOADING.START);
      this.$axios.delete('rest/bd/poste/suppression/' + poste.id).then(
        response => {
          if(this.$val.isDefined(this.form.postesEnCours[index])){
            this.form.postesEnCours.splice(index, 1)
          }
          else {
            this.form.postesFutur.splice(index, 1)
          }
          // Confirm message
          this.$eventHub.$emit(this.$eventHub.LOADING.END);
        },
        error => {
          this.$notify.error({
            title: this.$t('notifications.echecSuppression.title'),
            message: this.$t('notifications.echecSuppression.message')
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END);
        }
      )
    },

    /**
     * appelé lorsque la mise a jour des données s'est bien passée
     */
    success(response) {
      if (this.$val.isDefined(response.data.id)) {
        // On notifie l'erreur a l'utilisateur
        this.$notify.success({
          title: this.$t('notifications.success.title')
        })
      }
    },

    /**
     * appelé lorsque la mise a jour des données s'est mal passée
     */
    error(error) {
      //on notifie l'erreur a l'utilisateur
      this.$notify.error({
        title: this.$t('notifications.error.title'),
        message: this.$t('notifications.error.message')
      })
    },

  }
}
